import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Checkbox,
	Button,
	notification,
	Tag,
	Modal,
	Form,
	Row,
	Col,
	Upload,
	Table,
} from "antd";
import Layout from "../layout/Layout";
import { CustomSearch, CustomSpinner } from "../utils/CustomComponents";
import dayjs from "dayjs";
import {
	EyeOutlined,
	FilePdfOutlined,
	PlusSquareOutlined,
	RetweetOutlined,
	RollbackOutlined,
	UploadOutlined,
} from "@ant-design/icons";
import QAQCLoadsNotQC from "./QAQCLoadsNotQC";
import QAQCJobLoadsInternalModal from "./QAQCJobLoadsInternalModal";
const { Text } = Typography;

const QAQCUploadExternalReport = ({ history }) => {
	const [loading, setLoading] = useState(true);
	const [loadingTable, setLoadingTable] = useState(false);
	const [jobList, setJobList] = useState([]);
	const [allJobs, setAllJobs] = useState([]);
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());

	const [apiNotification, contextHolder] = notification.useNotification();

	const [editingJobId, setEditingJobId] = useState(null);
	const [dayTest, setDayTest] = useState(null);

	const [uploadModalOpen, setUploadModalOpen] = useState(false);
	const [uploadFileList, setUploadFileList] = useState([]);
	const [uploadForm] = Form.useForm();

	const [customer, setCustomer] = useState("All");
	const [customerList, setCustomerList] = useState([]);
	const [customerLoading, setCustomerLoading] = useState(true);

	const [jobId, setJobId] = useState("All");
	const [jobIdList, setJobIdList] = useState([]);
	const [jobLoading, setJobLoading] = useState(true);

	const [refresh, setRefresh] = useState(false);
	const [loadingButton, setLoadingButton] = useState(false);

	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [selectedJobs, setSelectedJobs] = useState([]);

	const [openModalNotQC, setOpenModalNotQC] = useState(false);
	const [selectedJob, setSelectedJob] = useState(null);
	const [modalOpenLoadsInternal, setModalOpenLoadsInternal] = useState(false);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Date",
			dataIndex: "scheduledDate",
			key: "scheduledDate",
			sorter: (a, b) =>
				dayjs(a.scheduledDate).valueOf() - dayjs(b.scheduledDate).valueOf(),
			render: (value) => {
				if (!value || !dayjs(value).isValid()) return "-";
				return <Text>{dayjs(value).format("MM/DD/YYYY hh:mm A")}</Text>;
			},
		},
		{
			title: "Job ID",
			dataIndex: "number",
			key: "number",
			sorter: (a, b) => Number(a.number) - Number(b.number),
			render: (value) => <Text strong>{value}</Text>,
		},
		{
			title: "Customer",
			dataIndex: "customer",
			key: "customer",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Loaded YD3",
			dataIndex: "loadYD3",
			key: "loadYD3",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Target YD3",
			dataIndex: "targetYD3",
			key: "targetYD3",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Plant",
			dataIndex: "plant",
			key: "plant",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Franchise",
			dataIndex: "franchise",
			key: "franchise",
			render: (value) => {
				return (
					<Tag
						color={
							value === "57Concrete"
								? "blue"
								: value === "Castle"
									? "green"
									: "cyan"
						}
					>
						{value}
					</Tag>
				);
			},
		},
		{
			title: "1 Day Test",
			dataIndex: "dayTest1",
			key: "dayTest1",
			render: (value, record) => (
				<Row gutter={[16, 16]}>
					<Col>
						<Button
							type="default"
							size="small"
							icon={<UploadOutlined />}
							onClick={() => {
								setEditingJobId(record.id);
								setDayTest(1);
								setUploadModalOpen(true);
							}}
							disabled={value}
						>
							Upload
						</Button>
					</Col>
					<Col>
						<Flex gap={10}>
							<Checkbox checked={value} />
							{value && (
								<Button
									type="default"
									size="small"
									icon={<EyeOutlined />}
									onClick={() => {
										const url = record.dayTest1EvidenceUrl;
										if (url) {
											window.open(url, "_blank", "noopener,noreferrer");
										}
									}}
								/>
							)}
						</Flex>
					</Col>
				</Row>
			),
		},
		{
			title: "3 Day Test",
			dataIndex: "dayTest3",
			key: "dayTest3",
			render: (value, record) => (
				<Row gutter={[16, 16]}>
					<Col>
						<Button
							type="default"
							size="small"
							icon={<UploadOutlined />}
							onClick={() => {
								setEditingJobId(record.id);
								setDayTest(3);
								setUploadModalOpen(true);
							}}
							disabled={value}
						>
							Upload
						</Button>
					</Col>
					<Col>
						<Flex gap={10}>
							<Checkbox checked={value} />
							{value && (
								<Button
									type="default"
									size="small"
									icon={<EyeOutlined />}
									onClick={() => {
										const url = record.dayTest3EvidenceUrl;
										if (url) {
											window.open(url, "_blank", "noopener,noreferrer");
										}
									}}
								/>
							)}
						</Flex>
					</Col>
				</Row>
			),
		},
		{
			title: "7 Day Test",
			dataIndex: "dayTest7",
			key: "dayTest7",
			render: (value, record) => (
				<Row gutter={[16, 16]}>
					<Col>
						<Button
							type="default"
							size="small"
							icon={<UploadOutlined />}
							onClick={() => {
								setEditingJobId(record.id);
								setDayTest(7);
								setUploadModalOpen(true);
							}}
							disabled={value}
						>
							Upload
						</Button>
					</Col>
					<Col>
						<Flex gap={10}>
							<Checkbox checked={value} />
							{value && (
								<Button
									type="default"
									size="small"
									icon={<EyeOutlined />}
									onClick={() => {
										const url = record.dayTest7EvidenceUrl;
										if (url) {
											window.open(url, "_blank", "noopener,noreferrer");
										}
									}}
								/>
							)}
						</Flex>
					</Col>
				</Row>
			),
		},
		{
			title: "14 Day Test",
			dataIndex: "dayTest14",
			key: "dayTest14",
			render: (value, record) => (
				<Row gutter={[16, 16]}>
					<Col>
						<Button
							type="default"
							size="small"
							icon={<UploadOutlined />}
							onClick={() => {
								setEditingJobId(record.id);
								setDayTest(14);
								setUploadModalOpen(true);
							}}
							disabled={value}
						>
							Upload
						</Button>
					</Col>
					<Col>
						<Flex gap={10}>
							<Checkbox checked={value} />
							{value && (
								<Button
									type="default"
									size="small"
									icon={<EyeOutlined />}
									onClick={() => {
										const url = record.dayTest14EvidenceUrl;
										if (url) {
											window.open(url, "_blank", "noopener,noreferrer");
										}
									}}
								/>
							)}
						</Flex>
					</Col>
				</Row>
			),
		},
		{
			title: "28 Day Test",
			dataIndex: "dayTest28",
			key: "dayTest28",
			render: (value, record) => (
				<Row gutter={[16, 16]}>
					<Col>
						<Button
							type="default"
							size="small"
							icon={<UploadOutlined />}
							onClick={() => {
								setEditingJobId(record.id);
								setDayTest(28);
								setUploadModalOpen(true);
							}}
							disabled={value}
						>
							Upload
						</Button>
					</Col>
					<Col>
						<Flex gap={10}>
							<Checkbox checked={value} />
							{value && (
								<Button
									type="default"
									size="small"
									icon={<EyeOutlined />}
									onClick={() => {
										const url = record.dayTest28EvidenceUrl;
										if (url) {
											window.open(url, "_blank", "noopener,noreferrer");
										}
									}}
								/>
							)}
						</Flex>
					</Col>
				</Row>
			),
		},
		{
			title: "56 Day Test",
			dataIndex: "dayTest56",
			key: "dayTest56",
			render: (value, record) => (
				<Row gutter={[16, 16]}>
					<Col>
						<Button
							type="default"
							size="small"
							icon={<UploadOutlined />}
							onClick={() => {
								setEditingJobId(record.id);
								setDayTest(56);
								setUploadModalOpen(true);
							}}
							disabled={value}
						>
							Upload
						</Button>
					</Col>
					<Col>
						<Flex gap={10}>
							<Checkbox checked={value} />
							{value && (
								<Button
									type="default"
									size="small"
									icon={<EyeOutlined />}
									onClick={() => {
										const url = record.dayTest56EvidenceUrl;
										if (url) {
											window.open(url, "_blank", "noopener,noreferrer");
										}
									}}
								/>
							)}
						</Flex>
					</Col>
				</Row>
			),
		},
		{
			title: "90 Day Test",
			dataIndex: "dayTest90",
			key: "dayTest90",
			render: (value, record) => (
				<Row gutter={[16, 16]}>
					<Col>
						<Button
							type="default"
							size="small"
							icon={<UploadOutlined />}
							onClick={() => {
								setEditingJobId(record.id);
								setDayTest(90);
								setUploadModalOpen(true);
							}}
							disabled={value}
						>
							Upload
						</Button>
					</Col>
					<Col>
						<Flex gap={10}>
							<Checkbox checked={value} />
							{value && (
								<Button
									type="default"
									size="small"
									icon={<EyeOutlined />}
									onClick={() => {
										const url = record.dayTest90EvidenceUrl;
										if (url) {
											window.open(url, "_blank", "noopener,noreferrer");
										}
									}}
								/>
							)}
						</Flex>
					</Col>
				</Row>
			),
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			render: (value) => {
				let color = "default";
				switch (value) {
					case "Closed":
						color = "green";
						break;
					case "Pending":
						color = "red";
						break;
					case "In Progress":
						color = "yellow";
						break;
					default:
						break;
				}
				return <Tag color={color}>{value}</Tag>;
			},
		},
		{
			title: "QC Type",
			dataIndex: "qcType",
			key: "qcType",
			render: (value, record) => {
				let color = "yellow";
				switch (value) {
					case "Internal":
						color = "purple";
						break;
					case "External":
						color = "blue";
						break;
					default:
						break;
				}
				return (
					<Flex gap={10}>
						<Tag color={color}>{value}</Tag>
						{value === "Not QC" && (
							<Button
								type="primary"
								icon={<PlusSquareOutlined />}
								onClick={() => {
									setSelectedJob(record);
									setOpenModalNotQC(true);
								}}
							/>
						)}
					</Flex>
				);
			},
		},
		{
			title: "Franchise",
			dataIndex: "franchise",
			key: "franchise",
			render: (value) => {
				return (
					<Tag
						color={
							value === "57Concrete"
								? "blue"
								: value === "Castle"
									? "green"
									: "cyan"
						}
					>
						{value}
					</Tag>
				);
			},
		},
		{
			title: "Actions",
			dataIndex: "actions",
			key: "actions",
			render: (_, record) => {
				const isDisabled =
					!record.prePourComplete ||
					!record.pourTestingComplete ||
					!record.afterPourComplete ||
					!record.hasAllValuesOfEticket;

				const isDisabledEReportInternal = !record.hasLoadsWithTesting;
				const isDisabledEReportExternal = !record.hasUploadExternal;
				return (
					<>
						{!record.qualityControl && (
							<Flex gap={10}>
								<Button
									type="primary"
									icon={<FilePdfOutlined />}
									onClick={() => {
										setSelectedJob(record);
										setModalOpenLoadsInternal(true);
									}}
								>
									Internal Test
								</Button>
							</Flex>
						)}
						{record.qualityControl && (
							<Flex gap={10}>
								<Button
									type="primary"
									icon={<FilePdfOutlined />}
									disabled={isDisabled}
									onClick={() => {
										history.push(`/qc/job/fieldreports/pdf/${record.id}`);
									}}
								>
									Field Report
								</Button>
								{record.qcType === "Internal" && (
									<Button
										type="primary"
										onClick={() => {
											history.push(
												`/qc/job/load/laboratory/all/pdf/${record.id}`,
											);
										}}
										disabled={isDisabledEReportInternal}
									>
										eReport
									</Button>
								)}
								{record.qcType === "External" && (
									<Button
										type="primary"
										onClick={() => generateLaboratoryOfExternal(record.id)}
										disabled={isDisabledEReportExternal}
									>
										eReport
									</Button>
								)}
							</Flex>
						)}
					</>
				);
			},
		},
	];

	const generateLaboratoryOfExternal = async (id) => {
		try {
			setLoadingTable(true);

			const url = api + `/job/generate/qc/uploadtexternal/${id}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.post(url);
			if (data.success) {
				const link = document.createElement("a");
				link.href = data.payload;
				link.download = "";
				document.body.appendChild(link);
				link.click();
				link.remove();
				openNotification("success", "Success", data.message);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoadingTable(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	useEffect(() => {
		getJobList();
		getJobIDList();
	}, [startDate, endDate, customer, refresh]);

	const getJobList = async () => {
		try {
			setLoadingTable(true);

			const start = `${startDate.year()}-${
				startDate.month() + 1
			}-${startDate.date()}`;
			const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

			const url =
				api +
				`/job/get/notqc/list?startDate=${start}&endDate=${end}&customer=${customer}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					const dayTest1 = item.qcData
						? item.qcData.dayTest1EvidenceUrl !== undefined
						: false;
					const dayTest3 = item.qcData
						? item.qcData.dayTest3EvidenceUrl !== undefined
						: false;
					const dayTest7 = item.qcData
						? item.qcData.dayTest7EvidenceUrl !== undefined
						: false;
					const dayTest14 = item.qcData
						? item.qcData.dayTest14EvidenceUrl !== undefined
						: false;
					const dayTest28 = item.qcData
						? item.qcData.dayTest28EvidenceUrl !== undefined
						: false;
					const dayTest56 = item.qcData
						? item.qcData.dayTest56EvidenceUrl !== undefined
						: false;
					const dayTest90 = item.qcData
						? item.qcData.dayTest90EvidenceUrl !== undefined
						: false;

					const tests = [
						dayTest1,
						dayTest3,
						dayTest7,
						dayTest14,
						dayTest28,
						dayTest56,
						dayTest90,
					];

					let status;

					if (tests.every((v) => v === true)) {
						status = "Closed";
					} else if (tests.some((v) => v === true)) {
						status = "In Progress";
					} else {
						status = "Pending";
					}
					list.push({
						key: index,
						id: item._id,
						number: item.number,
						franchise: item.franchise || "57Concrete",
						customer: item.customer.name,
						plant: item.plant.name,
						loadYD3: item.loadYD3,
						targetYD3: item.targetYD3,
						scheduledDate: item.scheduledDate,
						dayTest1: dayTest1,
						dayTest3: dayTest3,
						dayTest7: dayTest7,
						dayTest14: dayTest14,
						dayTest28: dayTest28,
						dayTest56: dayTest56,
						dayTest90: dayTest90,
						status: status,
						dayTest1EvidenceUrl: item.qcData
							? item.qcData.dayTest1EvidenceUrl
							: "",
						dayTest3EvidenceUrl: item.qcData
							? item.qcData.dayTest3EvidenceUrl
							: "",
						dayTest7EvidenceUrl: item.qcData
							? item.qcData.dayTest7EvidenceUrl
							: "",
						dayTest14EvidenceUrl: item.qcData
							? item.qcData.dayTest14EvidenceUrl
							: "",
						dayTest28EvidenceUrl: item.qcData
							? item.qcData.dayTest28EvidenceUrl
							: "",
						dayTest56EvidenceUrl: item.qcData
							? item.qcData.dayTest56EvidenceUrl
							: "",
						dayTest90EvidenceUrl: item.qcData
							? item.qcData.dayTest90EvidenceUrl
							: "",
						prePourComplete: item.qcData ? item.qcData.prePourComplete : false,
						pourTestingComplete: item.qcData
							? item.qcData.pourTestingComplete
							: false,
						afterPourComplete: item.qcData
							? item.qcData.afterPourComplete
							: false,
						hasAllValuesOfEticket: item.hasAllValuesOfEticket,
						hasLoadsWithTesting: item.hasLoadsWithTesting,
						hasUploadExternal: item.hasUploadExternal,
						qcType: item.qcType ?? "Not QC",
						qualityControl: item.qualityControl || false,
					});
				});
				setAllJobs(list);
				setJobList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
			setLoadingTable(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const getJobIDList = async () => {
		try {
			setJobLoading(true);

			const start = `${startDate.year()}-${
				startDate.month() + 1
			}-${startDate.date()}`;
			const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

			const url =
				api +
				`/job/get/notqc/list/ids?startDate=${start}&endDate=${end}&customer=${customer}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				let list = [
					{
						value: "All",
						label: "All",
					},
				];
				data.payload.map((item) => {
					list.push({
						label: item.number.toString(),
						value: item._id,
					});
				});
				setJobIdList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setJobLoading(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	useEffect(() => {
		if (jobId === "All") {
			setJobList(allJobs);
		} else {
			const filtered = allJobs.filter((job) => job.id === jobId);
			setJobList(filtered);
		}
	}, [jobId, allJobs]);

	useEffect(() => {
		setJobId("All");
	}, [customer]);

	useEffect(() => {
		getCustomers();
	}, []);

	const getCustomers = async () => {
		try {
			const url = api + "/customer/list/options/57Concrete";
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				let list = [
					{
						value: "All",
						label: "All",
					},
				];
				data.payload.map((item) => {
					list.push({
						label: `${item.customerNumber} ${item.name}`,
						value: item._id,
					});
				});
				setCustomerList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setCustomerLoading(false);
		} catch (err) {
			setCustomerLoading(false);
			openNotification("error", "Error", "Error while trying to get customers");
			console.error(err.message);
			return null;
		}
	};

	useEffect(() => {
		setSelectedRowKeys([]);
		setSelectedJobs([]);
	}, [jobList]);

	const rowSelection = {
		selectedRowKeys,
		onChange: (newSelectedRowKeys, selectedRows) => {
			setSelectedRowKeys(newSelectedRowKeys);
			setSelectedJobs(selectedRows.map((job) => job.id));
		},
		getCheckboxProps: (record) => ({
			disabled: !record.qualityControl,
		}),
	};

	const generateLaboratoryZipForJobs = async () => {
		try {
			setLoadingTable(true);

			const url = api + `/job/generate/qc/laboratory/zip`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.post(url, { jobIds: selectedJobs });
			if (data.success) {
				const link = document.createElement("a");
				link.href = data.payload;
				link.download = "";
				document.body.appendChild(link);
				link.click();
				link.remove();
				openNotification("success", "Success", data.message);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoadingTable(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const generateFieldReportZipForJobs = async () => {
		try {
			setLoadingTable(true);

			const url = api + `/job/generate/qc/fieldreport/zip`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.post(url, { jobIds: selectedJobs });
			if (data.success) {
				const link = document.createElement("a");
				link.href = data.payload;
				link.download = "";
				document.body.appendChild(link);
				link.click();
				link.remove();
				if (data.message.includes("ambient conditions")) {
					openNotification("warning", "Warning", data.message);
				} else {
					openNotification("success", "Success", data.message);
				}
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoadingTable(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Table
					columns={columns}
					dataSource={jobList}
					loading={loading || loadingTable}
					rowSelection={rowSelection}
					pagination={{
						position: ["bottomRight"],
						pageSizeOptions: [10, 20, 50, 100, 250, 500],
						defaultPageSize: 10,
						showSizeChanger: true,
					}}
					scroll={{
						x: 1300,
					}}
					style={{
						minWidth: "100%",
					}}
				/>
				<Flex gap={10}>
					<Button
						type="primary"
						size="large"
						disabled={selectedJobs.length === 0 || loadingTable}
						loading={loadingTable}
						onClick={generateFieldReportZipForJobs}
					>
						Field Report Zip
					</Button>
					<Button
						type="primary"
						size="large"
						disabled={selectedJobs.length === 0 || loadingTable}
						loading={loadingTable}
						onClick={generateLaboratoryZipForJobs}
					>
						eReport Zip
					</Button>
				</Flex>
			</Flex>
		);
	};

	const onRangeChange = (dates) => {
		if (dates) {
			setStartDate(dates[0]);
			setEndDate(dates[1]);
		}
	};

	const RenderSearch = () => (
		<Flex gap={10} align="end" justify="space-between">
			<CustomSearch
				loading={loading}
				startDate={startDate}
				endDate={endDate}
				onRangeChange={onRangeChange}
				dateFormat={"MM/DD/YYYY"}
				labelPicker={"Select customer"}
				pickerValue={customer}
				optionsPicker={customerList}
				onChangePicker={(v) => setCustomer(v)}
				allowClearPicker={false}
				pickerWidth={250}
				disabledPicker={customerLoading}
				labelPicker2={"Select Job ID"}
				pickerValue2={jobId}
				optionsPicker2={jobIdList}
				onChangePicker2={(v) => setJobId(v)}
				allowClearPicker2={false}
				pickerWidth2={250}
				disabledPicker2={jobLoading}
				pickerTitle={"Customer"}
				pickerTitle2={"Job ID"}
			/>

			<Button
				type="primary"
				onClick={() => setRefresh((prev) => !prev)}
				icon={<RetweetOutlined />}
				size="large"
				loading={loading}
			/>
		</Flex>
	);

	const goBack = () => {
		history.goBack();
	};

	const handleUploadImages = async () => {
		try {
			setLoadingButton(true);
			if (!uploadFileList.length) {
				openNotification("error", "No files", "Please select a PDF file");
				setLoadingButton(false);
				return;
			}

			const formData = new FormData();

			formData.append("file", uploadFileList[0].originFileObj);
			formData.append("dayTest", dayTest);

			const url = api + `/job/add/qc/daytest/${editingJobId}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
			const config = {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};

			const { data } = await axios.post(url, formData, config);
			if (data.success) {
				openNotification(
					"success",
					"Uploaded",
					`${dayTest} Day Test PDF added`,
				);
				setRefresh((prev) => !prev);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoadingButton(false);
			setUploadModalOpen(false);
			setUploadFileList([]);
			uploadForm.resetFields();
			setDayTest(null);
		} catch (err) {
			setLoadingButton(false);
			openNotification("error", "Error", err.message);
		}
	};

	const handleUploadChange = (info) => {
		setUploadFileList(info.fileList);
	};

	const RenderUploadImagesModal = useMemo(
		() => (
			<Modal
				title="Upload File"
				open={uploadModalOpen}
				onCancel={() => {
					if (loadingButton) return;

					setUploadModalOpen(false);
					setUploadFileList([]);
					uploadForm.resetFields();
					setDayTest(null);
				}}
				onOk={() => uploadForm.submit()}
				okButtonProps={{ disabled: loadingButton }}
				cancelButtonProps={{ disabled: loadingButton }}
				confirmLoading={loadingButton}
				destroyOnClose
				forceRender
				centered
			>
				<Form form={uploadForm} layout="vertical" onFinish={handleUploadImages}>
					<Form.Item
						label="PDF File"
						required
						rules={[{ required: true, message: "Please select file" }]}
						getValueFromEvent={(e) => {
							if (Array.isArray(e)) return e;
							return e?.fileList;
						}}
						valuePropName="fileList"
					>
						<Upload
							fileList={uploadFileList}
							maxCount={1}
							beforeUpload={() => false}
							onChange={handleUploadChange}
							accept=".pdf"
							showUploadList={{ showPreviewIcon: false, showRemoveIcon: false }}
						>
							<Button
								icon={<UploadOutlined />}
								size="large"
								disabled={loadingButton}
							>
								Upload
							</Button>
						</Upload>
					</Form.Item>
				</Form>
			</Modal>
		),
		[uploadModalOpen, uploadFileList, loadingButton],
	);

	return (
		<Layout title="Customer Test Reports" description="Report">
			<Flex vertical gap={16}>
				<Button
					type="primary"
					size="large"
					icon={<RollbackOutlined />}
					onClick={goBack}
					loading={loading}
					disabled={loading}
				/>
				<RenderSearch />
				{RenderUploadImagesModal}
				{loading ? <CustomSpinner /> : <RenderTable />}
				{contextHolder}
				<QAQCLoadsNotQC
					openModalNotQC={openModalNotQC}
					setOpenModalNotQC={setOpenModalNotQC}
					selectedJob={selectedJob}
					setSelectedJob={setSelectedJob}
				/>
				<QAQCJobLoadsInternalModal
					modalOpenLoads={modalOpenLoadsInternal}
					setModalOpenLoads={setModalOpenLoadsInternal}
					selectedJob={selectedJob}
					setSelectedJob={setSelectedJob}
					history={history}
				/>
			</Flex>
		</Layout>
	);
};

export default QAQCUploadExternalReport;
